import * as yup from "yup";

export default yup.object().shape({
  resetLevel: yup.number().moreThan(0).required()
});